import React, { Component } from 'react';
import { connect } from 'react-redux';
import dates from 'react-big-calendar/lib/utils/dates';
import cn from 'classnames';
import * as TimeSlotUtils from 'react-big-calendar/lib/utils/TimeSlots';
import TimeSlotGroupDaily from './TimeSlotGroupDaily';

class DayColumnTotal extends Component {

  renderSlot = (idx, renderSlot, slotMetrics, addStyle) => {
    if (idx !== 0) return null;
    const { getNow } = this.props;
    let employeeInfo = renderSlot || [];

    let headCounts = employeeInfo.length;

    const isNow = slotMetrics.dateIsInGroup(getNow(), idx);
    return (
      <span
        className={cn(
          'rbc-label',
          isNow && 'rbc-now',
          'spanstyle-default',
          addStyle
        )}
      >
        {headCounts}
      </span>
    );
  };

  render() {
    const {
      isNow,
      resource,
      daysEvents,
      date,
      step,
      timeslots
    } = this.props;

    const min = dates.startOf(date, 'day');
    const max = dates.endOf(date, 'day');

    let slotMetrics = TimeSlotUtils.getSlotMetrics({
      min,
      max,
      step,
      timeslots
    });

    return (
      <div
        className={cn(
          'rbc-day-slot',
          isNow && 'rbc-now',
          isNow && 'rbc-today',
          'totalstyle'
        )}
      >
        {slotMetrics.groups.map((grp, idx) => (
          <TimeSlotGroupDaily
            key={idx}
            group={grp}
            resource={resource}
            renderSlot={this.renderSlot}
            slotMetrics={slotMetrics}
            daysEvents={daysEvents}
          />
        ))}
        {/* <div className='rbc-time-slot'>
          <span className={cn('rbc-label', 'spanstyle')}>-</span>
        </div> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    displayWorkEvents: state.roster.displayAbsenceEvents,
    employees: state.roster.employeeList,
    selectedEmployee: state.roster.selectedEmployee,
    branches: state.BranchReducer.branchList,
    departments: state.DepartmentReducer.departmentList,
    actionTypes: state.ActionTypesReducer.actionTypes
  };
}

export default connect(mapStateToProps)(DayColumnTotal);
